import React from 'react';
import { ExternalLink, Github } from 'lucide-react';

export function ProjectModal({ project, isOpen, onClose }) {
  if (!project || !isOpen) return null;

  // Handle clicking outside modal to close
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white dark:bg-gray-800 max-w-2xl max-h-[90vh] w-full m-4 rounded-lg overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-2xl font-bold">{project.title}</h2>
        </div>

        {/* Content */}
        <div className="overflow-y-auto flex-grow p-6">
          <div className="space-y-6">
            <div className="relative aspect-video overflow-hidden rounded-lg">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            <p className="text-gray-600 dark:text-gray-300">{project.description}</p>
            
            <div className="space-y-2">
              <h3 className="font-semibold">Project Details</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300">{project.details}</p>
            </div>

            {project.technologies && project.technologies.length > 0 && (
              <div className="space-y-2">
                <h3 className="font-semibold">Technologies Used</h3>
                <div className="flex flex-wrap gap-2">
                  {project.technologies.map((tech) => (
                    <span 
                      key={tech} 
                      className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer with buttons */}
        {(project.demoUrl || project.githubUrl) && (
          <div className="border-t border-gray-200 dark:border-gray-700 p-6 flex gap-4">
            {project.demoUrl && (
              <a 
                href={project.demoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                <ExternalLink className="mr-2 h-4 w-4" />
                Live Demo
              </a>
            )}
            {project.githubUrl && (
              <a
                href={project.githubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <Github className="mr-2 h-4 w-4" />
                View Code
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}